import React from "react";
import EditUserInfoForm from "../../components/EditUserInfoForm/EditUserInfoForm";


const CompleteSignup = () => {
    
    return (
      <>
        <EditUserInfoForm />
      </>
    );
};



export default CompleteSignup;